import { AxiosResponse } from "axios";
import { WorkorderManagementBatch } from "../types/workorderManagementBatch";
import { WorkorderManagementBob } from "../types/workorderManagementBob";
import { WorkorderManagementBom } from "../types/workorderManagementBom";
import { WorkorderManagementData } from "../types/workorderManagementData";
import { WorkorderManagementMaterial } from "../types/workorderManagementMaterial";
import { WorkorderManagementOperation } from "../types/workorderManagementOperation";
import { aplClient } from "./apiClient";
import { convertToDateTime } from "../aplUtils/dateHelper";

const getWorkorderManagementData = (workorderId: string): Promise<AxiosResponse<WorkorderManagementData, any>> =>
    aplClient().get(`workorderManagementDatas/${workorderId}`);

const getWorkorderManagementMaterial = (workorderId: string): Promise<AxiosResponse<WorkorderManagementMaterial, any>> =>
    aplClient().get(`workorderManagementMaterials/byworkorder/${workorderId}`);

const getWorkorderManagementOperations = (workorderId: string): Promise<AxiosResponse<WorkorderManagementOperation[], any>> =>
    aplClient().get(`workorderManagementOperations/${workorderId}`);

const getWorkorderManagementBoms = (workorderId: string): Promise<AxiosResponse<WorkorderManagementBom[], any>> =>
    aplClient().get(`workorderManagementBoms/${workorderId}`);

const getWorkorderManagementBatches = (workorderId: string): Promise<AxiosResponse<WorkorderManagementBatch[], any>> =>
    aplClient().get(`workorderManagementBatches/${workorderId}`);

const getWorkorderManagementBobs = (workorderId: string): Promise<AxiosResponse<WorkorderManagementBob[], any>> =>
    aplClient().get(`workorderManagementBobs/${workorderId}`);

const saveWorkorderManagementData = (
    workorderManagementData: WorkorderManagementData
): Promise<AxiosResponse<WorkorderManagementData, any>> =>
    aplClient().put(`workorderManagementDatas/${workorderManagementData.workorderId}`, workorderManagementData);

const saveWorkordeManagementMaterial = (
    workorderManagementMaterial: WorkorderManagementMaterial
): Promise<AxiosResponse<WorkorderManagementMaterial, any>> =>
    aplClient().put(`workorderManagementMaterials/${workorderManagementMaterial.materialId}`, workorderManagementMaterial);

const saveWorkorderManagementOperation = (
    workorderManagementOperation: WorkorderManagementOperation
): Promise<AxiosResponse<WorkorderManagementOperation, any>> =>
    aplClient().put(`workorderManagementOperations/${workorderManagementOperation.operationId}`, workorderManagementOperation);

const savetWorkorderManagementBom = (workorderManagementBom: WorkorderManagementBom): Promise<AxiosResponse<WorkorderManagementBom, any>> =>
    aplClient().put(`workorderManagementBoms/${workorderManagementBom.woBomId}`);

const saveWorkorderManagementBom = (
    workorderManagementBom: WorkorderManagementBom
): Promise<AxiosResponse<WorkorderManagementBom[], any>> =>
    aplClient().put(`workorderManagementBoms/${workorderManagementBom.woBomId}`, workorderManagementBom);

const addWorkorderManagementBom = (workorderManagementBom: WorkorderManagementBom): Promise<AxiosResponse<WorkorderManagementBom[], any>> =>
    aplClient().post(`workorderManagementBoms`, workorderManagementBom);

const deleteWorkorderManagementBom = (
    workorderManagementBom: WorkorderManagementBom
): Promise<AxiosResponse<WorkorderManagementBom[], any>> => aplClient().delete(`workorderManagementBoms/${workorderManagementBom.woBomId}`);

const saveWorkorderManagementBatch = (
    workorderManagementBatch: WorkorderManagementBatch
): Promise<AxiosResponse<WorkorderManagementBatch, any>> =>
    aplClient().put(`workorderManagementBatches/${workorderManagementBatch.workOrderBatchId}`, {
        ...workorderManagementBatch,
        shiftStart: convertToDateTime(workorderManagementBatch.shiftStart),
        shiftEnd: convertToDateTime(workorderManagementBatch.shiftEnd)
    });

const addWorkorderManagementBatchDays = (
    workorderId: string,
    daysCount: number
): Promise<AxiosResponse<WorkorderManagementBatch, any>> =>
    aplClient().put(`workorderManagementBatches/${workorderId}/addDays/${daysCount}`);

const addWorkorderManagementBatch = (
    workorderManagementBatch: WorkorderManagementBatch
): Promise<AxiosResponse<WorkorderManagementBatch, any>> => aplClient().post(`workorderManagementBatches`, {
    ...workorderManagementBatch,
    shiftStart: convertToDateTime(workorderManagementBatch.shiftStart),
    shiftEnd: convertToDateTime(workorderManagementBatch.shiftEnd)
});

const deleteWorkorderManagementBatch = (
    workorderManagementBatch: WorkorderManagementBatch
): Promise<AxiosResponse<WorkorderManagementBatch[], any>> =>
    aplClient().delete(`workorderManagementBatches/${workorderManagementBatch.workOrderBatchId}`);

const addWorkorderManagementBob = (adding: { siteId: number; workorderId: string; batch: number }): Promise<AxiosResponse<WorkorderManagementBob[], any>> =>
    aplClient().post(`workorderManagementBobs`, adding);

const deleteWorkorderManagementBob = (
    woBobId: string
): Promise<AxiosResponse<WorkorderManagementBob[], any>> => aplClient().delete(`workorderManagementBobs/${woBobId}`);

const changeWorkorderManagementBobPriority = (
    workorderManagementBob: WorkorderManagementBob,
    priorityOffset: number
): Promise<AxiosResponse<WorkorderManagementBob[], any>> =>
    aplClient().put(`workorderManagementBobs/${workorderManagementBob.woBobId}/${priorityOffset}`, workorderManagementBob);

export {
    getWorkorderManagementData,
    getWorkorderManagementMaterial,
    getWorkorderManagementOperations,
    getWorkorderManagementBoms,
    getWorkorderManagementBatches,
    getWorkorderManagementBobs,
    saveWorkorderManagementData,
    saveWorkordeManagementMaterial,
    saveWorkorderManagementOperation,
    savetWorkorderManagementBom,
    saveWorkorderManagementBatch,
    changeWorkorderManagementBobPriority,
    addWorkorderManagementBob,
    deleteWorkorderManagementBob,
    saveWorkorderManagementBom,
    addWorkorderManagementBom,
    deleteWorkorderManagementBom,
    addWorkorderManagementBatch,
    deleteWorkorderManagementBatch,
    addWorkorderManagementBatchDays
};
